module.exports = __webpack_public_path__ + "img/thumb_image3.11c32046.jpg";